module.exports = __webpack_public_path__ + "img/terminal_occupied.3a237e76.png";